import { Button, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import classNames from "classnames";
import { useFavoriteProjects } from "in_queue/hooks/useFavoriteProjects";
import css from "./FavoriteProjectStar.module.scss";

export const FavoriteProjectStar: React.FC<{
    projectId: string;
    isFavorited: boolean;
}> = ({ projectId, isFavorited }) => {
    const { canToggleFavorite, setFavorite } = useFavoriteProjects();
    const icon = isFavorited ? IconNames.STAR : IconNames.STAR_EMPTY;
    if (!canToggleFavorite) {
        return (
            <Icon
                className={classNames(css["FavoriteProjectStar-static"], {
                    [css["FavoriteProjectStar--active"]]: isFavorited
                })}
                icon={icon}
            />
        );
    }
    return (
        <Button
            className={classNames(css["FavoriteProjectStar"], {
                [css["FavoriteProjectStar--active"]]: isFavorited
            })}
            icon={icon}
            aria-label={isFavorited ? "Unfavorite project" : "Favorite project"}
            aria-pressed={isFavorited}
            variant="minimal"
            size="small"
            onClick={() => setFavorite(projectId, !isFavorited)}
        />
    );
};
